import { Component, OnInit, NgZone, ViewChildren, QueryList, Input } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import $ from 'jquery';
import 'node_modules/jquery-ui/dist/jquery-ui.min.js';
import 'bootstrap';
import * as Quill from 'quill';

@Component({
  selector: 'pf-form-builder',
  templateUrl: './pf-form-builder.component.html',
  styleUrls: ['./pf-form-builder.component.css']
})
export class PfFormBuilderComponent implements OnInit {
  spinner = true;
  settingsOpen: boolean;
  viewMode = 'build';
  builderObject;
  optionsArr = [];
  formUrl = "";
  rules = [
    {effect: 'show', causeElement: '', effectElement: '', conditions: [{type: 'is', value: 'test'}]},
  ];
  formContent;
  @ViewChildren('optionItems') options: QueryList<any>;

  constructor(private route: ActivatedRoute,private httpClient:HttpClient, private ngZone:NgZone) { }
  
  renderSortableFieldOptions() {
    $(".option-items").empty();
    for (var i = 0; i < this.builderObject.children.length; i++) 
    {
      $(".option-items").append(`<li >
      <input type="text" value="` + this.builderObject.children[i] + `" class="sortable-item checkbox-custom fb-editor--option" data-value="{{item}}"/>
      <i class="fas fa-plus-circle option-add-item"></i>
      <i class="fas fa-minus-circle option-remove-item"></i>
      <i class="material-icons pf-icon move" >compare_arrows</i>
      </li>`);
    }
    this.initSortableItem();
    this.populateRuleOptions();
    $( ".option-items" ).sortable({
      handle:'.move',
      cancel: '',
      update:(event, ui)=>{
        var items = [];
        $( ".option-items > li" ).each(function(  ) {
          items.push($(this).find("input").val());
        });
        this.ngZone.run( () => {
          var arrayLength = items.length;
          this.builderObject.children = [];
          for (var i = 0; i < arrayLength; i++) {
            this.builderObject.children.push(items[i]);
            this.updateElementVisualContainer();
            this.updateBuilderObject();
          }
        });

      }
    });
  }

  changeViewMode(mode) {
    this.viewMode = mode;
    if(mode == 'build') {
      console.log("test");
      this.loadBuilder();
    }
  }

  updateBuilderObject() { //Update builderObject when a change is made
    let formContent = [];
    let itemId = -1;
    console.log("Updating Builder Object");
    //$("#" + this.builderObject.id).data("builderObj", this.builderObject);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    $(".form_builder_content").each(function(i,e) {
      let fObj = $(this).data("builderObj");
      formContent.push(fObj);
      formContent[i].children = [];
      $(this).find(".parent-field-item").each(function() {
        let cObj = $(this).data("builderObj");
        formContent[i].children.push(cObj);
      })
    });
    this.route.paramMap.subscribe(params => {
      itemId = +params.get('itemId');
      let bodyData = '{"formId":"' + itemId + '", "formContent": ' + JSON.stringify(formContent) + '}';
      this.httpClient.post<any>("/mvc/forms/UpdateFormById/",JSON.parse(bodyData), {headers: headers}).subscribe((res)=>{
        this.ngZone.run( () => {
          
        });
      });
    });
    this.formContent = formContent;
  }
  initSortableItem()
  {
    $(document).off("keyup", ".sortable-item");
    $(document).on("keyup", ".sortable-item" , (e,obj)=> {
      console.log("sortable item press");
      console.log(e);
      this.ngZone.run( () => {
          //this.updateBuilderObject();
          //this.renderSortableFieldOptions();
          //this.updateElementVisualContainer();
          var items = [];
        $( ".option-items > li" ).each(function(  ) {
          items.push($(this).find("input").val());
        });
        this.ngZone.run( () => {
          var arrayLength = items.length;
          this.builderObject.children = [];
          for (var i = 0; i < arrayLength; i++) {
            this.builderObject.children.push(items[i]);
            this.updateElementVisualContainer();
            //this.updateBuilderObject();
          }
        });
      });
    });
  }

  ngAfterViewInit() {
    this.options.changes.subscribe(t => {
      console.log(this.builderObject);
      if(typeof this.builderObject!=='undefined'){
        $(".option-items").empty();
        for (var i = 0; i < this.builderObject.children.length; i++) 
        {
          $(".option-items").append(`<li >
          <input type="text" value="` + this.builderObject.children[i] + `" class="sortable-item checkbox-custom fb-editor--option" data-value="{{item}}"/>
          <i class="fas fa-plus-circle option-add-item"></i>
          <i class="fas fa-minus-circle option-remove-item"></i>
          <i class="material-icons pf-icon move" >compare_arrows</i>
          </li>`);
        }
        this.initSortableItem();
        this.populateRuleOptions();
        this.ngForRender();
      }
    });
    this.spinner = false;
  }


  updateElementVisualContainer()
  {
    console.log("update");
    $("#" + this.builderObject.id).find(".field-name").text(this.builderObject.labelName);
    if(this.builderObject.type == 'radio' || this.builderObject.type == 'checkbox'){
      var listStyle = '';
      if(this.builderObject.type == 'radio')
      {
        listStyle = 'SCR_4b6ff';
      }
      console.log("should work");
      $("#" + this.builderObject.id).find(".element-visual-container").empty();
      for (var i = 0; i < this.builderObject.children.length; i++) 
      {
        if(i==0){
          $("#" + this.builderObject.id).find(".element-visual-container").append(`
            <div class="SCR_99112">
              <span class="SCR_e66de ` + listStyle + ` SCR_6f75f"></span>
              <span class="SCR_d1a56">` + this.builderObject.children[i] + `</span>
            </div>
          `);
        }else{
          $("#" + this.builderObject.id).find(".element-visual-container").append(`
            <div class="SCR_99112">
              <span class="SCR_e66de ` + listStyle + `"></span>
              <span class="SCR_d1a56">` + this.builderObject.children[i] + `</span>
            </div>
          `);
        }
        
      }
    }else if(this.builderObject.type=='description')
    {
      $("#" + this.builderObject.id).find(".element-visual-container").empty();
      $("#" + this.builderObject.id).find(".element-visual-container").append(this.builderObject.description);
    }

  }
  
  ngForRender() {
    $( ".option-items" ).sortable({
      handle:'.move',
      cancel: '',
      update:(event, ui)=>{
        console.log(ui.item);
        var items = [];
        $( ".option-items > li" ).each(function(  ) {
          items.push($(this).find("input").val());
        });
        console.log("update");
        console.log(items);
        this.ngZone.run( () => {
          var arrayLength = items.length;
          this.builderObject.children = [];
          for (var i = 0; i < arrayLength; i++) {
              this.builderObject.children.push(items[i]);
              this.updateElementVisualContainer();
          }
          console.log(this.builderObject.children);
        });

      }
    });
    console.log('NgFor is Rendered')
  }

  loadBuilder() {
    console.log('LOAD DAT BUILDER SONNNNNNNN!!!!!!!!!!!!');
    let tempThis = this;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let itemId = -1;
    this.route.paramMap.subscribe(params => {
      itemId = +params.get('itemId');
      var bodyData = '{"formId":"' + itemId + '"}';
        this.httpClient.post<any>("/mvc/forms/GetFormById/",JSON.parse(bodyData), {headers: headers}).subscribe((res)=>{
          this.ngZone.run( () => {
            console.log(res);
            if($.isEmptyObject(res[0]))
            {
              var guid = generateUUID();
              
              $(".init-content").attr("id", guid);
              var tempObj = {
                name: "First Section",
                logic: false,
                logicObject: [],
                hidden: false,
                readOnly: false,
                labelName: 'test',
                description: 'description test',
                type: "section",
                id: guid,
                children:[]
              }
              $(".init-content").data("builderObj", tempObj);
            } else {
              $(".form_builder_content_parent").empty();
              for (var i = 0; i < res[0].formContent.length; i++) {
                var getContent = $.parseHTML('<div class="form_builder-preview-empty vertical form_builder_content">            <div class="BPCB_df400"><div class="phx-Tooltip edit-section-builder-element"><div class="" data-tooltipped="" aria-describedby="tippy-tooltip-295" title="Field Properties" style="display: inline;"><button class="BPCB_27585 BPCB_8beca BPCB_b79ba BPCB_afed2" id="83546293-editButton"><i class="material-icons pf-icon">edit</i></button></div></div><div class="phx-Tooltip duplicate-section-builder-element"><div class="" data-tooltipped="" aria-describedby="tippy-tooltip-296" title="Duplicate" style="display: inline;"><button class="BPCB_27585 BPCB_b79ba" id="83546293-duplicateButton"><i class="material-icons pf-icon">filter_none</i></button></div></div><div class="phx-Tooltip remove-section-builder-element"><div class="" data-tooltipped="" aria-describedby="tippy-tooltip-297" title="Delete" style="display: inline;"><button class="BPCB_27585 BPCB_a5c7b" id="83546293-deleteButton"><i class="material-icons pf-icon">delete</i></button></div></div><div class="phx-Tooltip move-section-builder-element"><div class="" data-tooltipped="" aria-describedby="tippy-tooltip-298" title="Reorder" style="display: inline;"><button class="BPCB_27585 BPCB_de40d BPCB_d3e55 move-section" id="83546293-reorderButton"><i class="material-icons pf-icon">open_with</i></button></div></div></div></div>');//getContentByType(ui.draggable[0].id)
                //var guid = generateUUID();
              
                $(getContent).attr("id", res[0].formContent[i].id);
              
                $(getContent).data("builderObj", res[0].formContent[i]);
                for(var ci = 0; ci < res[0].formContent[i].children.length; ci++){
                  var getChildContent = getContentByType(res[0].formContent[i].children[ci].type);
                  $(getChildContent).find(".field-name").text(res[0].formContent[i].children[ci].labelName);
                  $(getChildContent).attr("id", res[0].formContent[i].children[ci].id);
                  $(getChildContent).data("builderObj", res[0].formContent[i].children[ci]);
                  $(getContent).append(getChildContent);
                  
                }
                $(".form_builder_content_parent").append(getContent);

                //appending child elements into form builder elements

                for(var ci = 0; ci < res[0].formContent[i].children.length; ci++){
                  if(res[0].formContent[i].children[ci].required == true)
                  {
                    $("#" + res[0].formContent[i].children[ci].id).addClass("required");
                  }
                  if(res[0].formContent[i].children[ci].type=='radio' || res[0].formContent[i].children[ci].type == 'checkbox')
                  {
                    console.log(res[0].formContent[i].children[ci]);
                    var listStyle = '';
                    if(res[0].formContent[i].children[ci].type == 'radio')
                    {
                      listStyle = 'SCR_4b6ff';
                    }
                    
                    $("#" + res[0].formContent[i].children[ci].id).find(".element-visual-container").empty();
                    for (var i2 = 0; i2 < res[0].formContent[i].children[ci].children.length; i2++) 
                    {
                      
                      if(i2==0){
                        
                        console.log('type radio children 1');
                        $("#" + res[0].formContent[i].children[ci].id).find(".element-visual-container").append(`
                          <div class="SCR_99112">
                            <span class="SCR_e66de ` + listStyle + ` SCR_6f75f"></span>
                            <span class="SCR_d1a56">` + res[0].formContent[i].children[ci].children[i2] + `</span>
                          </div>
                        `);
                      }else{
                        
                        console.log('type radio children other');
                        $("#" + res[0].formContent[i].children[ci].id).find(".element-visual-container").append(`
                          <div class="SCR_99112">
                            <span class="SCR_e66de ` + listStyle + `"></span>
                            <span class="SCR_d1a56">` + res[0].formContent[i].children[ci].children[i2] + `</span>
                          </div>
                        `);
                      }
                    }
                  }else if(res[0].formContent[i].children[ci].type=='description')
                  {
                    $("#" + res[0].formContent[i].children[ci].id).find(".element-visual-container").empty();
                    $("#" + res[0].formContent[i].children[ci].id).find(".element-visual-container").append(res[0].formContent[i].children[ci].description);
                  }
                }

              }
              $( ".form_builder-field--draggable").draggable({
                containment: $('body'),
                helper: 'clone',
                appendTo: '.form_builder_bin'
              });
          
              $( ".form_builder-field--draggable-section").draggable({
                containment: $('body'),
                helper: 'clone',
                appendTo: '.form_builder_bin'
              });
              initDroppable();
              
            }
            
          });
        });
      });

    function  getContentByType(type) {
      var editBtn = '<div class="phx-Tooltip edit-builder-element"><div class="" data-tooltipped="" aria-describedby="tippy-tooltip-295" title="Field Properties" style="display: inline;"><button class="BPCB_27585 BPCB_8beca BPCB_b79ba BPCB_afed2" id="83546293-editButton"><i class="material-icons pf-icon">edit</i></button></div></div>';
      var moveBtn = '<div class="phx-Tooltip move-builder-element"><div class="" data-tooltipped="" aria-describedby="tippy-tooltip-298" title="Reorder" style="display: inline;"><button class="BPCB_27585 BPCB_de40d BPCB_d3e55 move" id="83546293-reorderButton"><i class="material-icons pf-icon">open_with</i></button></div></div></div>';
      var deleteBtn = '<div class="phx-Tooltip remove-builder-element"><div class="" data-tooltipped="" aria-describedby="tippy-tooltip-297" title="Delete" style="display: inline;"><button class="BPCB_27585 BPCB_a5c7b" id="83546293-deleteButton"><i class="material-icons pf-icon">delete</i></button></div></div>';
      var copyBtn = '<div class="phx-Tooltip duplicate-builder-element"><div class="" data-tooltipped="" aria-describedby="tippy-tooltip-296" title="Duplicate" style="display: inline;"><button class="BPCB_27585 BPCB_b79ba" id="83546293-duplicateButton"><i class="material-icons pf-icon">filter_none</i></button></div></div>';
      var asterisk = '<span class="BPF_0f944 required-builder-element"><button id="fieldRequiredStatus-83546293" class="BPF_07523 BPF_9b314 phx-Button phx-Button--small phx-Button--edit phx-Button--noBackground phx-ActionButton" type="button"><i class="fas fa-asterisk"></i><span class="phx-Button-content"></span></button></span>';
      // Basic Fields
      let defaultElement = '<div class="BPR_5a071 BPR_f9164 parent-drag" role="grid"><div class="BPR_04f05 BPR_6b983 FieldDropZoneContainer"><div class="FieldDropTarget before paired vertical"></div><div class="FieldDropZoneContent"><div class="BPF_c0b57 BPCB_f0adf BPF_860d1 DH_97662 " role="gridcell" draggable="true"><div><div class="BPCB_41664 BPCB_df400"><div class="phx-Tooltip"><div class="" data-tooltipped="" aria-describedby="tippy-tooltip-246" title="Field Properties" style="display: inline;"><button class="BPCB_27585 BPCB_8beca BPCB_b79ba BPCB_afed2" id="83375868-editButton"><i class="fas fa-edit"></i></button></div></div><div class="phx-Tooltip"><div class="" data-tooltipped="" aria-describedby="tippy-tooltip-247" title="Duplicate" style="display: inline;"><button class="BPCB_27585 BPCB_b79ba" id="83375868-duplicateButton"><svg class="phx-Icon" style="height: 15px; width: 15px;"><use xlink:href="/admin/bower_components/bower-web-frontend/modules/42fa4d0699fabf82c499081f5474796f.svg#copy"></use></svg></button></div></div><div class="phx-Tooltip"><div class="" data-tooltipped="" aria-describedby="tippy-tooltip-248" title="Delete" style="display: inline;"><button class="BPCB_27585 BPCB_a5c7b" id="83375868-deleteButton"><svg class="phx-Icon" style="height: 15px; width: 15px;"><use xlink:href="/admin/bower_components/bower-web-frontend/modules/42fa4d0699fabf82c499081f5474796f.svg#trash"></use></svg></button></div></div><div class="phx-Tooltip"><div class="" data-tooltipped="" aria-describedby="tippy-tooltip-249" title="Reorder" style="display: inline;"><button class="BPCB_27585 BPCB_de40d BPCB_d3e55 move" id="83375868-reorderButton"><svg class="phx-Icon" style="height: 15px; width: 15px;"><use xlink:href="/admin/bower_components/bower-web-frontend/modules/42fa4d0699fabf82c499081f5474796f.svg#arrow-directional"></use></svg></button></div></div></div><div class="BPF_8ddcb"><span class="BPF_0f944"><button id="fieldRequiredStatus-83375868" class="BPF_07523 BPF_9b314 phx-Button phx-Button--small phx-Button--edit phx-Button--noBackground phx-ActionButton" type="button"><svg class="phx-Icon"><use xlink:href="/admin/bower_components/bower-web-frontend/modules/42fa4d0699fabf82c499081f5474796f.svg#asterisk"></use></svg><span class="phx-Button-content"></span></button></span><span class="BPF_fedaf field-name">Short Answer</span></div><div><div><div class="SI_82c66"></div></div></div></div></div></div><div class="FieldDropTarget paired vertical"></div></div></div>';
      
      let shortAnswer = '' + 
      '<div class="BPR_5a071 BPR_f9164 parent-field-item" role="grid">' +
        '<div class="BPR_04f05 BPR_6b983 FieldDropZoneContainer">' +
          '<div class="FieldDropTarget before paired vertical"></div>' +
          '<div class="FieldDropZoneContent">' + 
            '<div class="BPF_c0b57 BPCB_f0adf DH_97662" role="gridcell" draggable="true">' + 
              '<div>' + 
              '<div class="BPCB_df400">' + 
                editBtn + copyBtn + deleteBtn + moveBtn + 
                '<div class="BPF_8ddcb">' + 
                  asterisk +
                  '<span class="BPF_fedaf field-name">Short Answer</span>' + 
                '</div>' + 
                '<div>' + 
                  '<div>' + 
                    '<div class="SI_82c66"></div>' + 
                  '</div>' + 
                '</div>' + 
              '</div>' + 
            '</div>' + 
          '</div>' + 
          '<div class="FieldDropTarget paired vertical"></div>' + 
        '</div>' + 
      '</div>';

      let longAnswer = '<div class="BPR_5a071 BPR_f9164 parent-field-item" role="grid"><div class="BPR_04f05 BPR_6b983 FieldDropZoneContainer"><div class="FieldDropTarget before paired vertical"></div><div class="FieldDropZoneContent"><div class="BPF_c0b57 BPCB_f0adf DH_97662" role="gridcell" draggable="true"><div><div class="BPCB_df400">' + editBtn + copyBtn + deleteBtn + moveBtn + '<div class="BPF_8ddcb">' + asterisk + '<span class="BPF_fedaf field-name">Long Answer</span></div><div><div class="SI_82c66 SI_cd2a8"></div></div></div></div></div><div class="FieldDropTarget paired vertical"></div></div></div>';
      let dropdown = '<div class="BPR_5a071 BPR_f9164 parent-field-item" role="grid"><div class="BPR_04f05 BPR_6b983 FieldDropZoneContainer"><div class="FieldDropTarget before paired vertical"></div><div class="FieldDropZoneContent"><div class="BPF_c0b57 BPCB_f0adf DH_97662" role="gridcell" draggable="true"><div><div class="BPCB_df400">' + editBtn + copyBtn + deleteBtn + moveBtn + '<div class="BPF_8ddcb">' + asterisk + '<span class="BPF_fedaf field-name">Dropdown List</span></div><div><div class="SS_5ef08"><span class="SS_a301a">Option1</span><div class="SS_4aa97">' + '<i class="fas fa-chevron-down" style="transform: rotate(270deg);"></i>' + '</div></div></div></div></div></div><div class="FieldDropTarget paired vertical"></div></div></div>';
      let name = '<div class="BPR_5a071 BPR_f9164 parent-field-item" role="grid"><div class="BPR_04f05 BPR_6b983 FieldDropZoneContainer"><div class="FieldDropTarget before paired vertical"></div><div class="FieldDropZoneContent"><div class="BPF_c0b57 BPCB_f0adf DH_97662" role="gridcell" draggable="true"><div><div class="BPCB_df400">' + editBtn + copyBtn + deleteBtn + moveBtn + '<div class="BPF_8ddcb">' + asterisk + '<span class="BPF_fedaf field-name">Name</span></div><div><div><span class="NF_8194d"><span class="NF_4161b"><div class="SI_82c66"></div></span><span class="NF_4161b"><div class="SI_82c66"></div></span></span><span class="NF_c699f"><span class="NF_4161b">First Name</span><span class="NF_4161b">Last Name</span></span></div></div></div></div></div><div class="FieldDropTarget paired vertical"></div></div></div>';
      let address = '<div class="BPR_5a071 BPR_f9164 parent-field-item" role="grid"><div class="BPR_04f05 BPR_6b983 FieldDropZoneContainer"><div class="FieldDropTarget before paired vertical"></div><div class="FieldDropZoneContent"><div class="BPF_c0b57 BPCB_f0adf DH_97662" role="gridcell" draggable="true"><div><div class="BPCB_df400">' + editBtn + copyBtn + deleteBtn + moveBtn + '<div class="BPF_8ddcb">' + asterisk + '<span class="BPF_fedaf field-name">Address</span></div><div><div><div class="AF_66d39"><span class="AF_9e717"><div class="SI_82c66"></div></span><span class="AF_34f13">Address Line 1</span></div><div class="AF_771b0"><span class="AF_9e717"><div class="SI_82c66"></div></span><span class="AF_34f13">Address Line 2</span></div><span class="AF_9e717"><span class="AF_4424d"><div class="SI_82c66"></div></span><span class="AF_dc91f"><div class="SS_5ef08"><span class="SS_a301a"></span><div class="SS_4aa97"><svg class="phx-Icon"><use xlink:href="/admin/bower_components/bower-web-frontend/modules/42fa4d0699fabf82c499081f5474796f.svg#arrow-caret-left"></use></svg><svg class="phx-Icon"><use xlink:href="/admin/bower_components/bower-web-frontend/modules/42fa4d0699fabf82c499081f5474796f.svg#arrow-caret-right"></use></svg></div></div></span><span class="AF_27994"><div class="SI_82c66"></div></span></span><span class="AF_34f13"><span class="AF_4424d">City</span><span class="AF_dc91f">State</span><span class="AF_27994">ZIP Code</span></span></div></div></div></div></div><div class="FieldDropTarget paired vertical"></div></div></div>';
      let emailAddress = '<div class="BPR_5a071 BPR_f9164 parent-field-item" role="grid"><div class="BPR_04f05 BPR_6b983 FieldDropZoneContainer"><div class="FieldDropTarget before paired vertical"></div><div class="FieldDropZoneContent"><div class="BPF_c0b57 BPCB_f0adf DH_97662" role="gridcell" draggable="true"><div><div class="BPCB_df400">' + editBtn + copyBtn + deleteBtn + moveBtn + '<div class="BPF_8ddcb">' + asterisk + '<span class="BPF_fedaf field-name">Email</span></div><div><div><div class="SI_82c66"></div></div></div></div></div></div><div class="FieldDropTarget paired vertical"></div></div></div>';
      let phone = '<div class="BPR_5a071 BPR_f9164 parent-field-item" role="grid"><div class="BPR_04f05 BPR_6b983 FieldDropZoneContainer"><div class="FieldDropTarget before paired vertical"></div><div class="FieldDropZoneContent"><div class="BPF_c0b57 BPCB_f0adf DH_97662" role="gridcell" draggable="true"><div><div class="BPCB_df400">' + editBtn + copyBtn + deleteBtn + moveBtn + '<div class="BPF_8ddcb">' + asterisk + '<span class="BPF_fedaf field-name">Phone</span></div><div><div class="SI_82c66"></div></div></div></div></div><div class="FieldDropTarget paired vertical"></div></div></div>';
      let number = '<div class="BPR_5a071 BPR_f9164 parent-field-item" role="grid"><div class="BPR_04f05 BPR_6b983 FieldDropZoneContainer"><div class="FieldDropTarget before paired vertical"></div><div class="FieldDropZoneContent"><div class="BPF_c0b57 BPCB_f0adf DH_97662" role="gridcell" draggable="true"><div><div class="BPCB_df400">' + editBtn + copyBtn + deleteBtn + moveBtn + '<div class="BPF_8ddcb">' + asterisk + '<span class="BPF_fedaf field-name">Number</span></div><div><div class="NF_b04ee"><div class="SI_82c66"></div></div></div></div></div></div><div class="FieldDropTarget paired vertical"></div></div></div>';
      let checkbox = '<div class="BPR_5a071 BPR_f9164 parent-field-item" role="grid"><div class="BPR_04f05 BPR_6b983 FieldDropZoneContainer"><div class="FieldDropTarget before paired vertical"></div><div class="FieldDropZoneContent"><div class="BPF_c0b57 BPCB_f0adf DH_97662" role="gridcell" draggable="true"><div><div class="BPCB_df400">' + editBtn + copyBtn + deleteBtn + moveBtn + '<div class="BPF_8ddcb">' + asterisk + '<span class="BPF_fedaf field-name">Checkbox</span></div><div><div class="CRF_56028 CRF_fd2dd element-visual-container"><div class="SCR_99112"><span class="SCR_e66de SCR_6f75f"></span><span class="SCR_d1a56">Option1</span></div><div class="SCR_99112"><span class="SCR_e66de"></span><span class="SCR_d1a56">Option2</span></div><div class="SCR_99112"><span class="SCR_e66de"></span><span class="SCR_d1a56">Option3</span></div></div></div></div></div></div><div class="FieldDropTarget paired vertical"></div></div></div>';
      let radio = '<div class="BPR_5a071 BPR_f9164 parent-field-item" role="grid"><div class="BPR_04f05 BPR_6b983 FieldDropZoneContainer"><div class="FieldDropTarget before paired vertical"></div><div class="FieldDropZoneContent"><div class="BPF_c0b57 BPCB_f0adf DH_97662" role="gridcell" draggable="true"><div><div class="BPCB_df400">' + editBtn + copyBtn + deleteBtn + moveBtn + '<div class="BPF_8ddcb">' + asterisk + '<span class="BPF_fedaf field-name">Radio Button</span></div><div><div class="CRF_56028 CRF_fd2dd element-visual-container"><div class="SCR_99112"><span class="SCR_e66de SCR_4b6ff SCR_6f75f"></span><span class="SCR_d1a56">Option1</span></div><div class="SCR_99112"><span class="SCR_e66de SCR_4b6ff"></span><span class="SCR_d1a56">Option2</span></div><div class="SCR_99112"><span class="SCR_e66de SCR_4b6ff"></span><span class="SCR_d1a56">Option3</span></div></div></div></div></div></div><div class="FieldDropTarget paired vertical"></div></div></div>';
      //Advanced
      let creditcard = '<div class="BPR_5a071 BPR_f9164 parent-field-item" role="grid"><div class="BPR_04f05 BPR_6b983 FieldDropZoneContainer"><div class="FieldDropTarget before paired vertical"></div><div class="FieldDropZoneContent"><div class="BPF_c0b57 BPCB_f0adf DH_97662" role="gridcell" draggable="true"><div><div class="BPCB_df400">' + editBtn + copyBtn + deleteBtn + moveBtn + '<div class="BPF_8ddcb">' + asterisk + '<span class="BPF_fedaf field-name">Credit Card</span></div><div><div class="CF_fde97"><span class="CF_ce4ee"><span class="CF_d2397"><svg class="phx-Icon" style="color: rgb(158, 167, 175); height: 12px; width: 12px;"><use xlink:href="/admin/bower_components/bower-web-frontend/modules/42fa4d0699fabf82c499081f5474796f.svg#credit-card"></use></svg><div class="SI_82c66 SI_177fd SI_10130">0000 0000 0000 0000</div></span><span class="CF_5ddb3"><div class="SI_82c66 SI_177fd SI_10130">MM / YY</div></span><span class="CF_5ddb3"><div class="SI_82c66 SI_177fd SI_10130">CVC</div></span></span><div class="phx-Indicator phx-Indicator--information phx-Indicator--small phx-Indicator--no-background"><div class="phx-Indicator-header"><svg class="phx-Icon" style="height: 15px; width: 15px;"><use xlink:href="/admin/bower_components/bower-web-frontend/modules/42fa4d0699fabf82c499081f5474796f.svg#info-circle"></use></svg><div class="phx-IndicatorTitle">You must enable&nbsp;<a href="/admin/form/settings/3612699/integrations">a credit card processing integration</a>.</div></div></div></div></div></div></div></div><div class="FieldDropTarget paired vertical"></div></div></div>';
      let datetime = '<div class="BPR_5a071 BPR_f9164 parent-field-item" role="grid"><div class="BPR_04f05 BPR_6b983 FieldDropZoneContainer"><div class="FieldDropTarget before paired vertical"></div><div class="FieldDropZoneContent"><div class="BPF_c0b57 BPCB_f0adf DH_97662" role="gridcell" draggable="true"><div><div class="BPCB_df400">' + editBtn + copyBtn + deleteBtn + moveBtn + '<div class="BPF_8ddcb">' + asterisk + '<span class="BPF_fedaf field-name">Date/Time</span></div><div><div class="DF_66085"><div class="DF_8ee4e">' + 
        '<div class="SS_5ef08"><span class="SS_a301a"></span><div class=""><i class="fas fa-caret-up" style="position: absolute;margin-top: -12px;margin-left: -12px;"></i><i class="fas fa-caret-down" style="position: absolute;margin-top: -3px;margin-left: -12px;"></i></div></div>' + 
        '<div class="SS_5ef08"><span class="SS_a301a"></span><div class=""><i class="fas fa-caret-up" style="position: absolute;margin-top: -12px;margin-left: -12px;"></i><i class="fas fa-caret-down" style="position: absolute;margin-top: -3px;margin-left: -12px;"></i></div></div>' + 
        '<div class="SS_5ef08"><span class="SS_a301a"></span><div class=""><i class="fas fa-caret-up" style="position: absolute;margin-top: -12px;margin-left: -12px;"></i><i class="fas fa-caret-down" style="position: absolute;margin-top: -3px;margin-left: -12px;"></i></div></div>' + 
        '</div></div></div></div></div></div><div class="FieldDropTarget paired vertical"></div></div></div>';
      let fileupload = '<div class="BPR_5a071 BPR_f9164 parent-field-item" role="grid"><div class="BPR_04f05 BPR_6b983 FieldDropZoneContainer"><div class="FieldDropTarget before paired vertical"></div><div class="FieldDropZoneContent"><div class="BPF_c0b57 BPCB_f0adf DH_97662" role="gridcell" draggable="true"><div><div class="BPCB_df400">' + editBtn + copyBtn + deleteBtn + moveBtn + '<div class="BPF_8ddcb">' + asterisk + '<span class="BPF_fedaf field-name">File</span></div><div><div class="FF_e3db6"><span class="FF_7970c">Choose File</span><span class="FF_39387">No File Selected</span></div></div></div></div></div><div class="FieldDropTarget paired vertical"></div></div></div>';
      let matrix = '<div class="BPR_5a071 BPR_f9164 parent-field-item" role="grid"><div class="BPR_04f05 BPR_6b983 FieldDropZoneContainer"><div class="FieldDropTarget before paired vertical"></div><div class="FieldDropZoneContent"><div class="BPF_c0b57 BPCB_f0adf DH_97662" role="gridcell" draggable="true"><div><div class="BPCB_df400">' + editBtn + copyBtn + deleteBtn + moveBtn + '<div class="BPF_8ddcb">' + asterisk + '<span class="BPF_fedaf field-name">Matrix</span></div><div><div class="MF_615fe"><div class="MF_f7986"><div class="MF_55675"><div class="MF_73835"></div><div class="MF_73835">Column 1</div><div class="MF_73835">Column 2</div><div class="MF_73835">Column 3</div></div><div class="MF_55675"><div class="MF_73835">Row 1</div><div class="MF_73835"><div class="SCR_99112"><span class="SCR_e66de SCR_4b6ff"></span></div></div><div class="MF_73835"><div class="SCR_99112"><span class="SCR_e66de SCR_4b6ff"></span></div></div><div class="MF_73835"><div class="SCR_99112"><span class="SCR_e66de SCR_4b6ff"></span></div></div></div><div class="MF_55675"><div class="MF_73835">Row 2</div><div class="MF_73835"><div class="SCR_99112"><span class="SCR_e66de SCR_4b6ff"></span></div></div><div class="MF_73835"><div class="SCR_99112"><span class="SCR_e66de SCR_4b6ff"></span></div></div><div class="MF_73835"><div class="SCR_99112"><span class="SCR_e66de SCR_4b6ff"></span></div></div></div><div class="MF_55675"><div class="MF_73835">Row 3</div><div class="MF_73835"><div class="SCR_99112"><span class="SCR_e66de SCR_4b6ff"></span></div></div><div class="MF_73835"><div class="SCR_99112"><span class="SCR_e66de SCR_4b6ff"></span></div></div><div class="MF_73835"><div class="SCR_99112"><span class="SCR_e66de SCR_4b6ff"></span></div></div></div></div></div></div></div></div></div><div class="FieldDropTarget paired vertical"></div></div></div>';
      let description = '<div class="BPR_5a071 BPR_f9164 parent-field-item" role="grid"><div class="BPR_04f05 BPR_6b983 FieldDropZoneContainer"><div class="FieldDropTarget before paired vertical"></div><div class="FieldDropZoneContent"><div class="BPF_c0b57 BPCB_f0adf DH_97662" role="gridcell" draggable="true"><div><div class="BPCB_df400">' + editBtn + copyBtn + deleteBtn + moveBtn + '<div class="BPF_8ddcb">' + '<span class="BPF_0f944"></span></div><div class=" element-visual-container"><div class="RTF_bfeea"><div class="RTF_8079e"><p>Description Area</p></div></div></div></div></div></div><div class="FieldDropTarget paired vertical"></div></div></div>';
      let code = '<div class="BPR_5a071 BPR_f9164 parent-field-item" role="grid"><div class="BPR_04f05 BPR_6b983 FieldDropZoneContainer"><div class="FieldDropTarget before paired vertical"></div><div class="FieldDropZoneContent"><div class="BPF_c0b57 BPCB_f0adf DH_97662" role="gridcell" draggable="true"><div><div class="BPCB_df400">' + editBtn + copyBtn + deleteBtn + moveBtn + '<div class="BPF_8ddcb">' + asterisk + '<span class="BPF_0f944"></span></div><div><div class="CF_f848e"><svg class="phx-Icon" style="color: rgb(21, 35, 43); height: 21px; width: 21px;"><use xlink:href="/admin/bower_components/bower-web-frontend/modules/42fa4d0699fabf82c499081f5474796f.svg#code"></use></svg><div class="CF_2e72e">Embed Code</div></div></div></div></div></div><div class="FieldDropTarget paired vertical"></div></div></div>';
      let eventProduct = '<div class="BPR_5a071 BPR_f9164 parent-field-item" role="grid"><div class="BPR_04f05 BPR_6b983 FieldDropZoneContainer"><div class="FieldDropTarget before paired vertical"></div><div class="FieldDropZoneContent"><div class="BPF_c0b57 BPCB_f0adf DH_97662" role="gridcell" draggable="true"><div><div class="BPCB_df400">' + editBtn + copyBtn + deleteBtn + moveBtn + '<div class="BPF_8ddcb">' + asterisk + '<span class="BPF_fedaf  field-name">Event/Product</span></div><div><div class="PF_5f620"><div class="PF_44403">Event description goes here...</div><div class="PF_86cd3"><span class="PF_3f6a1">$3.99</span><span class="PF_53db4"><span>Quantity:</span><span class="PF_1206e"><div class="SS_5ef08"><span class="SS_a301a"></span><div class="SS_4aa97"><svg class="phx-Icon"><use xlink:href="/admin/bower_components/bower-web-frontend/modules/42fa4d0699fabf82c499081f5474796f.svg#arrow-caret-left"></use></svg><svg class="phx-Icon"><use xlink:href="/admin/bower_components/bower-web-frontend/modules/42fa4d0699fabf82c499081f5474796f.svg#arrow-caret-right"></use></svg></div></div></span></span></div></div></div></div></div></div><div class="FieldDropTarget paired vertical"></div></div></div>';
      let signature = '<div class="BPR_5a071 BPR_f9164 parent-field-item" role="grid"><div class="BPR_04f05 BPR_6b983 FieldDropZoneContainer"><div class="FieldDropTarget before paired vertical"></div><div class="FieldDropZoneContent"><div class="BPF_c0b57 BPCB_f0adf DH_97662" role="gridcell" draggable="true"><div><div class="BPCB_df400">' + editBtn + copyBtn + deleteBtn + moveBtn + '<div class="BPF_8ddcb">' + asterisk + '<span class="BPF_fedaf  field-name">Signature</span></div><div><div class="CF_f848e CF_cb405"><div class="CF_2e72e">Signature Area</div></div><span class="STP_9b9bb">Use your mouse or finger to draw your signature above</span></div></div></div></div><div class="FieldDropTarget paired vertical"></div></div></div>';
      let rating = '<div class="BPR_5a071 BPR_f9164 parent-field-item" role="grid"><div class="BPR_04f05 BPR_6b983 FieldDropZoneContainer"><div class="FieldDropTarget before paired vertical"></div><div class="FieldDropZoneContent"><div class="BPF_c0b57 BPCB_f0adf DH_97662" role="gridcell" draggable="true"><div><div class="BPCB_df400">' + editBtn + copyBtn + deleteBtn + moveBtn + '<div class="BPF_8ddcb">' + asterisk + '<span class="BPF_fedaf  field-name">Rating</span></div><div><div class="RF_6199e"><span class="fsRatingShape"><svg class="phx-Icon"><use xlink:href="/admin/bower_components/bower-web-frontend/modules/42fa4d0699fabf82c499081f5474796f.svg#star"></use></svg></span><span class="fsRatingShape"><svg class="phx-Icon"><use xlink:href="/admin/bower_components/bower-web-frontend/modules/42fa4d0699fabf82c499081f5474796f.svg#star"></use></svg></span><span class="fsRatingShape"><svg class="phx-Icon"><use xlink:href="/admin/bower_components/bower-web-frontend/modules/42fa4d0699fabf82c499081f5474796f.svg#star"></use></svg></span><span class="fsRatingShape"><svg class="phx-Icon"><use xlink:href="/admin/bower_components/bower-web-frontend/modules/42fa4d0699fabf82c499081f5474796f.svg#star"></use></svg></span><span class="fsRatingShape"><svg class="phx-Icon"><use xlink:href="/admin/bower_components/bower-web-frontend/modules/42fa4d0699fabf82c499081f5474796f.svg#star-hollow"></use></svg></span></div></div></div></div></div><div class="FieldDropTarget paired vertical"></div></div></div>';
      var retContent = "";
      switch (type) { 
        case 'shortAnswer': 
          retContent = shortAnswer;
          break;
        case 'longAnswer':
          retContent = longAnswer;
          break;
        case 'dropdown': 
          retContent = dropdown
          break;
        case 'name':
          retContent = name;
          break;
        case 'address':
          retContent = address;
          break;
        case 'emailAddress':
          retContent = emailAddress;
          break;
        case 'phone':
          retContent = phone;
          break;
        case 'number':
          retContent = number;
          break;
        case 'checkbox':
          retContent = checkbox;
          break;
        case 'radio':
          retContent = radio;
          break;
        case 'creditcard':
          retContent = creditcard;
          break;
        case 'datetime':
          retContent = datetime;
          break;
        case 'fileupload':
          retContent = fileupload;
          break;
        case 'matrix':
          retContent = matrix;
          break;
        case 'description':
          retContent = description;
          break;
        case 'code':
          retContent = code;
          break;
        case 'eventProduct':
          retContent = eventProduct;
          break;
        case 'signature':
          retContent = signature;
          break;
        case 'rating':
          retContent = rating;
          break;
        default:
          retContent = defaultElement;
      }
      return $.parseHTML(retContent);
    }

    function generateUUID() { // Public Domain/MIT
      var d = new Date().getTime();//Timestamp
      var d2 = (performance && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random() * 16;//random number between 0 and 16
          if(d > 0){//Use timestamp until depleted
              r = (d + r)%16 | 0;
              d = Math.floor(d/16);
          } else {//Use microseconds since page-load if supported
              r = (d2 + r)%16 | 0;
              d2 = Math.floor(d2/16);
          }
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
    }

    function initDroppable() {
      $( "div.form_builder_content" ).droppable({
        accept:'.form_builder-field--draggable',
        drop: function( event, ui ) {
          var guid = generateUUID();
          var getContent = getContentByType(ui.draggable[0].id);
          $(getContent).attr("id", guid);
          var tempObj = {
            name: $(ui.draggable[0]).attr("name"),
            logic: false,
            logicObject: [],
            required: false,
            hidden: false,
            readOnly: false,
            labelName: 'test',
            placeHolder: 'placeholder test',
            description: 'description test',
            type: ui.draggable[0].id,
            id: guid,
            children:["Option1", "Option2"]
          }
          $(getContent).data("builderObj", tempObj);
          tempThis.ngZone.run( () => {
            console.log("ngZone");
            console.log(tempObj);
            this.builderObject = tempObj;
            console.log(this.builderObject);
            this.settingsOpen = true;
          });
          
          if(!$(this).hasClass("parent-drag")){
            
            if ($(this).find(".placeholder").length > 0) //add first element when cart is empty
            {
                $(this).find(".placeholder").remove();
                $(this).append(getContent);
            } else {

                var i = 0;

                $(this).children('div').each(function () {
                    if ($(this).offset().top >= ui.offset.top) //compare
                    {
                        //$("<li></li>").text(ui.draggable.text()).insertBefore($(this));
                        $(this).before(getContent);
                        i = 1;
                        return false; //break loop
                    }
                })

                if (i != 1) //if element dropped at the end of cart
                {
                  $(this).append(getContent);

                    //$("<li></li>").text(ui.draggable.text()).appendTo(this);
                }

            }
            
            //$( ".parent-drag" ).draggable();
            console.log("test drop");
          }
          tempThis.updateBuilderObject();
        }
      }); 
      $( "div.form_builder_content" ).sortable({
        handle:'.move',
        cancel: '',
        connectWith: "div.form_builder_content"
      });
      
    }
        
    $(document).ready((e)=> {



      
      
      
      // Delete Button click
      // Unbind element so it doesnt compound when ngOnInit is hit again.
      $(document).off("click", ".remove-builder-element");
      $(document).on("click", ".remove-builder-element" , (e,obj)=> {
        $(e.currentTarget).closest(".parent-field-item").remove();
        this.ngZone.run( () => {
          this.updateBuilderObject();
        });
      });


      // Delete Section Button click
      // Unbind element so it doesnt compound when ngOnInit is hit again.
      $(document).off("click", ".remove-section-builder-element");
      $(document).on("click", ".remove-section-builder-element" , (e,obj)=> {
        $(e.currentTarget).closest(".form_builder_content").remove();
        this.ngZone.run( () => {
          this.updateBuilderObject();
        });
      });

      // Duplicate Button click
      // Unbind element so it doesnt compound when ngOnInit is hit again.
      $(document).off("click", ".duplicate-builder-element");
      $(document).on("click", ".duplicate-builder-element" , (e, obj)=> {
        var parentElement = $(e.currentTarget).closest(".parent-field-item");
        var newElement = parentElement.clone();
        var tempObj = $(parentElement).data("builderObj");
        var guid = generateUUID();
        tempObj.id = guid;
        $(newElement).data("builderObj", tempObj);
        $(newElement).attr("id",guid);
        newElement.insertAfter(parentElement);
        //console.log(guid);
        //console.log($("#" + guid).data("builderObj"));
        this.ngZone.run( () => {
          this.builderObject=tempObj;
          this.updateBuilderObject();
        });
      });

      // Edit Button click
      // Unbind element so it doesnt compound when ngOnInit is hit again.
      $(document).off("click", ".edit-builder-element");
      $(document).on("click", ".edit-builder-element" , (e, obj)=> { 
        var parentElement = $(e.currentTarget).closest(".parent-field-item");
        var dObj = $(parentElement).data("builderObj");
        console.log(e.currentTarget);
        this.ngZone.run( () => {
          this.builderObject=dObj;
          //console.log(this.builderObject);
          
          var myEditor = document.querySelector('.editor')
          myEditor.children[0].innerHTML = this.builderObject.description;
          this.settingsOpen = true;
          this.renderSortableFieldOptions();
          this.updateBuilderObject();
        });
        e.preventDefault();
        e.stopPropagation();
      });

      // Asterisk Button click
      //disable and renable event so it doesnt compound.
      $(document).off("click", ".option-add-item");
      $(document).on("click", ".option-add-item" ,(e, obj)=> {
        var parentElement = $(e.currentTarget).closest("li");
        
        $(parentElement).after(`
          <li>
            <input type="text" value="" class="sortable-item checkbox-custom fb-editor--option" data-value="{{item}}"/>
              <i class="fas fa-plus-circle option-add-item"></i>
              <i class="fas fa-minus-circle option-remove-item"></i>
              <i class="material-icons pf-icon move" >compare_arrows</i>
          </li>
        `);
        //console.log("after");
        var items = [];
        $( ".option-items > li" ).each(function(  ) {
          items.push($(this).find("input").val());
        });
        //console.log(items);
        this.initSortableItem();
        this.ngZone.run( () => {
          var arrayLength = items.length;
          this.builderObject.children = items;
          this.updateBuilderObject();
          this.updateElementVisualContainer();
        });
        e.preventDefault();
        e.stopPropagation();
      });
      //Close field options
      //disable and renable event so it doesnt compound.
      $(document).off("click", ".closeSettings");
      $(document).on("click", ".closeSettings", (e,obj)=>
      {
       
        this.ngZone.run( () => {
          this.settingsOpen=false;
          this.updateBuilderObject();
        });
        $( ".form_builder-field--draggable").draggable({
          containment: $('body'),
          helper: 'clone',
          appendTo: '.form_builder_bin'
        });
      
        $( ".form_builder-field--draggable-section").draggable({
          containment: $('body'),
          helper: 'clone',
          appendTo: '.form_builder_bin'
        });
      });

      //get logic change
      //disable and renable event so it doesnt compound.
      $(document).off("change", ".logicElement");
      $(document).on("change", ".logicElement" ,(e, obj)=> {
        console.log("select change!!!");
        var arrayNum = $(e.currentTarget).attr("num");
        var optionSelected = $(e.currentTarget).find("option:selected");
        var valueSelected  = optionSelected.val();


        //
        var valData = $("#" + valueSelected).data("builderObj");
        console.log(valData);
        var optionContent = "";
        $.each(valData.children, function() {
        
          let optionValue = this;
          optionContent += '<option value="' + optionValue + '">' + optionValue + '</option>';
          
        });
        $("select[name='value'][num='" + arrayNum + "']").empty();
        $("select[name='value'][num='" + arrayNum + "']").append(optionContent);
        $("select[name='value'][num='" + arrayNum + "']").val(valData.children[0]);
        //


        
        console.log(arrayNum);
        console.log(valueSelected);
        this.ngZone.run( () => {
          this.builderObject.logicObject[arrayNum].id = valueSelected;
          this.builderObject.logicObject[arrayNum].isOperand = 'is';
          this.builderObject.logicObject[arrayNum].value = valData.children[0];
          this.updateBuilderObject();
        });
        
        e.preventDefault();
        e.stopPropagation();
      });
      
      //get logic change
      //disable and renable event so it doesnt compound.
      $(document).off("change", ".logicOperation");
      $(document).on("change", ".logicOperation" ,(e, obj)=> {
        console.log("select change!!!");
        var arrayNum = $(e.currentTarget).attr("num");
        var optionSelected = $(e.currentTarget).find("option:selected");
        var valueSelected  = optionSelected.val();
        
        console.log(arrayNum);
        console.log(valueSelected);
        this.ngZone.run( () => {
          this.builderObject.logicObject[arrayNum].isOperand = valueSelected;
          this.updateBuilderObject();
        });
        
        e.preventDefault();
        e.stopPropagation();
      });
      
      //get logic change
      //disable and renable event so it doesnt compound.
      $(document).off("change", ".logicValue");
      $(document).on("change", ".logicValue" ,(e, obj)=> {
        console.log("select change!!!");
        var arrayNum = $(e.currentTarget).attr("num");
        var optionSelected = $(e.currentTarget).find("option:selected");
        var valueSelected  = optionSelected.val();
        
        console.log(arrayNum);
        console.log(valueSelected);
        this.ngZone.run( () => {
          this.builderObject.logicObject[arrayNum].value = valueSelected;
          this.updateBuilderObject();
        });
        
        e.preventDefault();
        e.stopPropagation();
      });
      
      //remove multi field options
      //disable and renable event so it doesnt compound.
      $(document).off("click", ".option-remove-item");
      $(document).on("click", ".option-remove-item" ,(e, obj)=> {
        var parentElement = $(e.currentTarget).closest("li");
        
        $(parentElement).remove();
        var items = [];
        $( ".option-items > li" ).each(function(  ) {
          items.push($(this).find("input").val());
        });
        console.log(items);
    
        this.ngZone.run( () => {
          var arrayLength = items.length;
          this.builderObject.children = items;
          this.updateBuilderObject();
          this.updateElementVisualContainer();
        });
        
        e.preventDefault();
        e.stopPropagation();
      });
      //required field options
      //disable and renable event so it doesnt compound.
      $(document).off("click", ".required-builder-element");
      $(document).on("click", ".required-builder-element" , (e)=> {
        //alert('required boi');
          var el = $(e.currentTarget).closest(".parent-field-item");
          console.log(el);
          var bData = $(el).data("builderObj");
          if(bData.required == true)
          {
            bData.required=false;
            $(el).removeClass("required");
          }else
          {
            bData.required=true;
            $(el).addClass("required");
          }
          $(el).data(bData,"builderObj");
          if(this.builderObject==='undefined')
          {
            this.builderObject=bData;
          }
          this.updateBuilderObject();
      });

      $( ".form_builder-field--draggable").draggable({
        containment: $('body'),
        helper: 'clone',
        appendTo: '.form_builder_bin'
      });

      $( ".form_builder-field--draggable-section").draggable({
        containment: $('body'),
        helper: 'clone',
        appendTo: '.form_builder_bin'
      });
      
      $( "div.form_builder_content" ).sortable({
        handle:'.move',
        cancel: '',
        connectWith: "div.form_builder_content",
        update: function(e) {
          this.updateBuilderObject();
          //console.log(e);
          // do stuff
       }
      });
      
      $( "div.form_builder_content_parent" ).sortable({
        handle:'.move-section',
        cancel: ''
      });

      $( "div.form_builder_content_parent" ).droppable({
        accept:'.form_builder-field--draggable-section',
        drop: function( event, ui ) {
          var getContent = $.parseHTML('<div class="form_builder-preview-empty vertical form_builder_content">            <div class="BPCB_df400"><div class="phx-Tooltip edit-section-builder-element"><div class="" data-tooltipped="" aria-describedby="tippy-tooltip-295" title="Field Properties" style="display: inline;"><button class="BPCB_27585 BPCB_8beca BPCB_b79ba BPCB_afed2" id="83546293-editButton"><i class="material-icons pf-icon">edit</i></button></div></div><div class="phx-Tooltip duplicate-section-builder-element"><div class="" data-tooltipped="" aria-describedby="tippy-tooltip-296" title="Duplicate" style="display: inline;"><button class="BPCB_27585 BPCB_b79ba" id="83546293-duplicateButton"><i class="material-icons pf-icon">filter_none</i></button></div></div><div class="phx-Tooltip remove-section-builder-element"><div class="" data-tooltipped="" aria-describedby="tippy-tooltip-297" title="Delete" style="display: inline;"><button class="BPCB_27585 BPCB_a5c7b" id="83546293-deleteButton"><i class="material-icons pf-icon">delete</i></button></div></div><div class="phx-Tooltip move-section-builder-element"><div class="" data-tooltipped="" aria-describedby="tippy-tooltip-298" title="Reorder" style="display: inline;"><button class="BPCB_27585 BPCB_de40d BPCB_d3e55 move-section" id="83546293-reorderButton"><i class="material-icons pf-icon">open_with</i></button></div></div></div><span class="placeholder"><span class="form_builder-empty"><i class="material-icons form_builder-empty-icon">crop_free</i></span><p class="form_builder-content-empty-header">Welcome to your blank form!</p><p class="form_builder-content-empty-subheader">Drag and drop fields from the left to this area.</p></span></div>');//getContentByType(ui.draggable[0].id)
          var guid = generateUUID();
          
          $(getContent).attr("id", guid);
          var tempObj = {
            name: $(ui.draggable[0]).attr("name"),
            logic: false,
            logicObject: [],
            hidden: true,
            readOnly: false,
            labelName: 'test',
            description: 'description test',
            type: "section",
            id: guid,
            children:[]
          }
          $(getContent).data("builderObj", tempObj);
          if(!$(this).hasClass("parent-drag")){
            
            if ($(this).find(".placeholder").length > 0) //add first element when cart is empty
            {
                $(this).find(".placeholder").remove();
                $(this).append(getContent);
                initDroppable();
            } else {

                var i = 0;

                $(this).children('div').each(function () {
                    if ($(this).offset().top >= ui.offset.top) //compare
                    {
                        //$("<li></li>").text(ui.draggable.text()).insertBefore($(this));
                        $(this).before(getContent);
                        initDroppable();
                        i = 1;
                        return false; //break loop
                    }
                })

                if (i != 1) //if element dropped at the end of cart
                {
                  $(this).append(getContent);
                  initDroppable();

                    //$("<li></li>").text(ui.draggable.text()).appendTo(this);
                }

            }
            
            //$( ".parent-drag" ).draggable();
            //console.log("test");
          }
        }
      });
      initDroppable();
    });
    
  }

  ngOnInit() {
    this.loadBuilder();
    var toolbarOptions = [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'font': [] }],
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      [{ 'direction': 'rtl' }],                         // text direction
      // custom dropdown
    
      [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      
      [{ 'align': [] }],
    
      ['image']    ,
      ['showHtml']                                     // remove formatting button
    ];
    var container = $('.editor').get(0);
    var options = {
      placeholder: 'Compose an epic...',
      modules: {
        toolbar: toolbarOptions
      },
      theme: 'snow'
    };
    function base64ImageToBlob(str) {
      // extract content type and base64 payload from original string
      var pos = str.indexOf(';base64,');
      var type = str.substring(5, pos);
      var b64 = str.substr(pos + 8);
    
      // decode base64
      var imageContent = atob(b64);
    
      // create an ArrayBuffer and a view (as unsigned 8-bit)
      var buffer = new ArrayBuffer(imageContent.length);
      var view = new Uint8Array(buffer);
    
      // fill the view, using the decoded base64
      for(var n = 0; n < imageContent.length; n++) {
        view[n] = imageContent.charCodeAt(n);
      }
    
      // convert ArrayBuffer to Blob
      var blob = new Blob([buffer], { type: type });
    
      return blob;
    }
    
    var fileName;
    $(document).on("change", 'input[type="file"]' , (e,obj)=> {
        fileName = e.target.files[0].name;
        alert('The file "' + fileName +  '" has been selected.');
    });
    function uploadImageToImgurAndReplaceSrc($image) {
      
      
      var imageBase64 = $image.attr('src').split(',')[1];
      var uploadFile = base64ImageToBlob($image.attr('src'));
      $('#progressbar').show()
      var formData = new FormData();
      //alert
      var associatedGroup = localStorage.getItem('guid').toString();
      formData.append("path", associatedGroup + '/');
      formData.append("file", uploadFile, fileName);
      $.ajax({
        url: '/mvc/ImageBrowser/upload',  
        type: 'POST',
        data: formData,
        success: function(response){ 
          //alert("success");
          $image.attr('src', 'http://dev.theproforms.com/mvc/ImageBrowser/Image?path=' + associatedGroup + '/' + fileName);
          $('#progressbar').hide()
          updateInProgress = false;
      }, 
        cache: false,
        contentType: false,
        processData: false
      });
     
    }
    let updateInProgress = false;
    var editor = new Quill(container, options);
    


    var txtArea = document.createElement('textarea');
    txtArea.style.cssText = "width: 100%;margin: 0px;background: rgb(29, 29, 29);box-sizing: border-box;color: rgb(204, 204, 204);font-size: 15px;outline: none;padding: 20px;line-height: 24px;font-family: Consolas, Menlo, Monaco, &quot;Courier New&quot;, monospace;position: absolute;top: 0;bottom: 0;border: none;display:none"
    
    var htmlEditor = editor.addContainer('ql-custom')
    htmlEditor.appendChild(txtArea)
    
    var myEditor = document.querySelector('.editor')
    editor.on('text-change', (delta, oldDelta, source) => {
      if (source == 'api') {
        console.log("An API call triggered this change.");
      } else if (source == 'user') {
        console.log("A user action triggered this change.");
      }
      var html = myEditor.children[0].innerHTML
      console.log(html);
      txtArea.value = html
    })
    
    var customButton = document.querySelector('.ql-showHtml');
    customButton.addEventListener('click', function() {
      if (txtArea.style.display === '') {
        var html = txtArea.value
        //editor.clipboard.dangerouslyPasteHTML(html)
        //var htmlToInsert = "<p>here is some <strong>awesome</strong> text</p>"
        var editor = document.getElementsByClassName('ql-editor')
        editor[0].innerHTML = html;
        
        console.log(html);
      }
      txtArea.style.display = txtArea.style.display === 'none' ? '' : 'none'
    });


    
    editor.on('editor-change', () => {
      
      if (updateInProgress) return;
      
      var $images = $('.editor img')
      $images.each(function () {
        var imageSrc = $(this).attr('src')
        console.log("check");
        if (imageSrc && imageSrc[0] === 'd') {
          console.log('Starting image upload...')
          updateInProgress = true
          //if(imageSrc.indexOf("base64") >= 0)
          //{
            uploadImageToImgurAndReplaceSrc($(this))
          //}
          
        }
      })
    })
  }
  saveDescription()
  {
    var myEditor = document.querySelector('.editor')
    var htmlContent = myEditor.children[0].innerHTML
    this.builderObject.description = htmlContent;
    
    this.ngZone.run( () => {
      this.updateElementVisualContainer();
      this.updateBuilderObject();
    });
    $("#editorModal").modal('hide');
    
  }

  saveFormUrl(url) {
    //.log(url);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let itemId = -1;
    this.route.paramMap.subscribe(params => {
      itemId = +params.get('itemId');
      var bodyData = '{"formId":"' + itemId + '", "url": "' + url + '"}';
      this.httpClient.post<any>("/mvc/forms/UpdateFormUrl/",JSON.parse(bodyData), {headers: headers}).subscribe((res)=>{
        this.ngZone.run( () => {
          //console.log(res);
          
          $("#formUrlModal").modal('hide');
        
        });
      });
    });
  }
  
  populateRuleOptions() {
    $('select[name="operand"]').empty();
    $('select[name="value"]').empty();
    var tempObj = this.builderObject;
    $.each(this.formContent, function() {
      console.log("num");
      var outerIndex = 0;
      $.each(this.children, function(index, value) {
        if(this.type == 'dropdown' || this.type == 'radio' || this.type == 'checkbox') {
          let optionValue = this.id;
          let optionText = this.labelName;
          console.log(this);
          console.log(index)
          $('select[name="operand"]').append(`<option value="${optionValue}">${optionText}</option>`);
          
          $('select[name="value"]').each(function( iindex ) {
            if(iindex==outerIndex){
              console.log(outerIndex);
              console.log(tempObj);
              if(tempObj.logicObject != []){
                var valData = $("#" + tempObj.logicObject[outerIndex].id).data("builderObj");
                console.log(valData);
                var optionContent = "";
                $.each(valData.children, function() {
                
                  let optionValue = this;
                  optionContent += '<option value="' + optionValue + '">' + optionValue + '</option>';
                  
                });
                $(this).append(optionContent);
              }
            }
            
          });
          outerIndex++;
        }
      });
    });
    $('select[name="operand"]').each(function( iindex ) {
        $(this).val(tempObj.logicObject[iindex].id);
    });
    $('select[name="value"]').each(function( iindex ) {
        $(this).val(tempObj.logicObject[iindex].value);
    });
    $('select[name="operation"]').each(function( iindex ) {
        $(this).val(tempObj.logicObject[iindex].isOperand);
    });
  }

  addNewRule() {
    this.builderObject.logic = true;
    var firstRuleId = "";
    var firstChild = "";
    $.each(this.formContent, function() {
      $.each(this.children, function(index, value) {
        if(this.type == 'dropdown' || this.type == 'radio' || this.type == 'checkbox') {
          if(firstRuleId == ""){
            firstRuleId = this.id;
            firstChild = this.children[0];
          }
        }
      })
    })
    let newRule = {id: firstRuleId, isOperand:'is', value:firstChild };
    if(this.builderObject.logicObject == null) {
      this.builderObject.logicObject = [];
    }
    this.builderObject.logicObject.push(newRule);
    console.log(this.builderObject);
    this.updateBuilderObject();
  }

  removeRule() {
    this.builderObject.logicObject.pop();
    if(this.builderObject.logicObject.length == 0) {
      this.builderObject.logic = false;
      console.log(' now false');
    }
    console.log(this.builderObject);
    this.updateBuilderObject();
  }
  openEditorModal()
  {
    $("#editorModal").modal('show');
    
    
  }

  openFormUrlModal() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let itemId = -1;
    this.route.paramMap.subscribe(params => {
      itemId = +params.get('itemId');
      var bodyData = '{"formId":"' + itemId + '"}';
        this.httpClient.post<any>("/mvc/forms/GetFormUrlById/",JSON.parse(bodyData), {headers: headers}).subscribe((res)=>{
          this.ngZone.run( () => {
            //console.log(res[0].formUrl);
            this.formUrl = res[0].formUrl;
            $(".formUrl-input").val(res[0].formUrl);
            $(".formUrl-input").attr("data-value",res[0].formUrl);
            $("#formUrlModal").modal('show');
              
          });
        });
      });
    
  }
  readOnlyCheckBoxChange(state, event) {
    if(state==false)
    {
      this.builderObject.readOnly=true;
    }
    else
    {
      this.builderObject.readOnly=false;
    }
  }
  uniqueCheckBoxChange(state, event) {
    if(state==false)
    {
      this.builderObject.uniqueField=true;
    }
    else
    {
      this.builderObject.uniqueField=false;
    }
  }
  hiddenCheckBoxChange(state, event) {
    if(state==false)
    {
      this.builderObject.hidden=true;
    }
    else
    {
      this.builderObject.hidden=false;
    }
  }
  requiredCheckBoxChange(requiredState, event) {
    if(requiredState==false)
    {
      this.builderObject.required=true;
      $("#" + this.builderObject.id).removeClass("required");
    }
    else
    {
      this.builderObject.required=false;
      $("#" + this.builderObject.id).addClass("required");
    }
    if(this.builderObject.required==false)
    {
      $("#" + this.builderObject.id).removeClass("required");
    }else
    {
      $("#" + this.builderObject.id).addClass("required");
    }
    this.updateBuilderObject();
  }
  
}
